/**
 * 项目概览统计卡片组件
 */
import React from 'react';
import { Row, Col, Card, Statistic } from 'antd';
import {
  DollarOutlined,
  PercentageOutlined,
  RiseOutlined,
  CalendarOutlined
} from '@ant-design/icons';
import type { ProjectOverviewData } from '../../services/dashboardService';
import { calculateBudgetHealth, formatMoney } from '../../utils/budgetUtils';

interface OverviewStatsProps {
  project: ProjectOverviewData;
  stats: any;
  isMobile?: boolean;
}

const OverviewStats: React.FC<OverviewStatsProps> = ({
  project,
  stats,
  isMobile = false
}) => {
  const totalCost = stats?.summary?.totalProjectCost || project.actualCost || 0;
  const budgetHealth = calculateBudgetHealth(project.budget, totalCost);

  const cardStyle = {
    height: '100%',
    borderRadius: 8
  };

  const statCards = [
    {
      title: '项目总成本',
      value: totalCost,
      prefix: <DollarOutlined />,
      formatter: (val: number) => formatMoney(val, false),
      backgroundColor: '#fff1f0',
      color: '#cf1322'
    },
    {
      title: '预算使用率',
      value: budgetHealth.percentage,
      prefix: <PercentageOutlined />,
      suffix: '%',
      precision: 1,
      backgroundColor: budgetHealth.status === 'unset' ? '#f5f5f5' : 
                       budgetHealth.percentage <= 70 ? '#f6ffed' : 
                       budgetHealth.percentage <= 90 ? '#fff7e6' : '#fff1f0',
      color: budgetHealth.color
    },
    {
      title: '项目进度',
      value: project.progress,
      prefix: <RiseOutlined />,
      suffix: '%',
      backgroundColor: '#f0f5ff',
      color: '#1677ff'
    },
    {
      title: '剩余天数',
      value: project.daysRemaining,
      prefix: <CalendarOutlined />,
      suffix: '天',
      backgroundColor: '#fff7e6',
      color: project.daysRemaining <= 7 ? '#f5222d' : 
             project.daysRemaining <= 30 ? '#fa8c16' : '#52c41a'
    }
  ];

  return (
    <Row gutter={[isMobile ? 8 : 16, isMobile ? 8 : 16]} style={{ marginBottom: isMobile ? 16 : 24 }}>
      {statCards.map((card, index) => (
        <Col xs={12} sm={12} md={6} key={index}>
          <Card
            size="small"
            style={{
              ...cardStyle,
              backgroundColor: card.backgroundColor
            }}
            bodyStyle={{ padding: isMobile ? '12px' : '16px' }}
          >
            <Statistic
              title={<span style={{ fontSize: isMobile ? 12 : 14 }}>{card.title}</span>}
              value={card.formatter ? card.formatter(card.value) : card.value}
              prefix={card.prefix}
              suffix={card.suffix}
              precision={card.precision}
              valueStyle={{
                color: card.color,
                fontSize: isMobile ? 18 : 24
              }}
            />
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default OverviewStats;
